/*=========================================================================================
  File Name: gettes.js
  Description: Cart Getters
  ----------------------------------------------------------------------------------------
  Item Name: Fujisushi Web app
  Author: Tan Tran
==========================================================================================*/
import PriceCalculator from "../../../commons/priceCalculator";
export default {
    totalPrice : (state) => {
        let total = 0;
        state.selectedItems.forEach(item => {
            let finalPrice = PriceCalculator.getProductPrice(item.itemPrice, item.addedPrice, item.discount);
            total += ( item.quantity * Math.round(finalPrice) );
        });
        return total;
    },
    totalTax : (state) => {
        let total = 0;
        state.selectedItems.forEach(item => {
            let finalPrice = PriceCalculator.getProductPrice(item.itemPrice, item.addedPrice, item.discount);
            total += (item.quantity * item.tax * Math.round(finalPrice)) / 100.0;
        });
        return total.toFixed(2);
    },
    itemsCount : (state) => {
        let count = 0;
        state.selectedItems.forEach(item => {
            console.log(item)
            count += parseInt(item.quantity, 10);
        });
        //console.log('itemsCount:' + count);
        return count;
    },

    itemsInCart : (state) => {
        let items = [];
        console.log('itemsInCart');
        state.selectedItems.forEach( i => {
            let item = {
                index : i.index,
                itemId : i.itemId,
                itemName : i.itemName,
                imageUrl : i.imageUrl,
                categoryName : i.categoryName,
                itemPrice : i.itemPrice,
                addedPrice : i.addedPrice,
                discount : i.discount,
                quantity : i.quantity,
                tax : i.tax,
                options : JSON.stringify(i.options),
                shortDescription : i.shortDescription,
                comment : i.comment,
                estimatedTime : i.estimatedTime
            };
            items.push(item);
        });
        
        //console.log(items)
        return items;
    },

    storedItems : (state) => {
        let items = [];
        state.selectedItems.forEach( i => {
            let item = {
                itemId : i.itemId,
                itemName : i.itemName,
                categoryName : i.categoryName,
                itemPrice : i.itemPrice,
                quantity : i.quantity,
                addedPrice : i.addedPrice,
                tax : i.tax,
                discount: i.discount,
                description : i.description,
                imageUrl : i.imageUrl
            };
            items.push(item);
        });
        return items;
    }
}